import React from 'react';
import { FadeIn, Section } from './Shared';
export const SolutionSection = () => {
  return <Section bg="teal" className="text-center relative overflow-hidden" data-id="element-288">
      {/* Decorative leaves */}
      <div className="absolute top-0 left-0 opacity-10 pointer-events-none transform -translate-x-1/2 -translate-y-1/2" data-id="element-289">
        <svg width="300" height="300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-290">
          <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-291" />
          <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-292" />
        </svg>
      </div>
      <div className="absolute bottom-0 right-0 opacity-10 pointer-events-none transform translate-x-1/3 translate-y-1/3" data-id="element-293">
        <svg width="300" height="300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-294">
          <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-295" />
          <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-296" />
        </svg>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-297">
        <FadeIn data-id="element-298">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-5 shadow-lg" data-id="element-299">
            <span className="text-4xl" data-id="element-300">💚</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-301">
          <h2 className="text-5xl md:text-6xl font-bold mb-5 text-white font-heading tracking-wide" data-id="element-302">
            HÍGADO VITAL
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-303">
          <p className="text-2xl md:text-3xl text-brand-cream font-medium leading-relaxed" data-id="element-304">
            Un protocolo simple de 14 días que trabaja con tu cuerpo, no contra
            él.
          </p>
        </FadeIn>
      </div>
    </Section>;
};